import { render, staticRenderFns } from "./MoreMessageBox.vue?vue&type=template&id=1371fb2a&scoped=true&lang=pug&"
import script from "./MoreMessageBox.vue?vue&type=script&lang=ts&"
export * from "./MoreMessageBox.vue?vue&type=script&lang=ts&"
import style0 from "./MoreMessageBox.vue?vue&type=style&index=0&id=1371fb2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1371fb2a",
  null
  
)

export default component.exports